import { Facebook } from "@/assets/icons/Facebook";
import { Share } from "@/assets/icons/Share";
import { Tweeter } from "@/assets/icons/Tweeter";

import { cleanHTML, stripHTML } from "@/features/news/utils/techcrunchHtmlParser";

import { OtherNewsSkeleton } from "@/shared/components/OtherNewsSkeleton";
import { useLocation } from "react-router-dom";
import { Article } from "@/domain/Article";

export const SingleNewPage = () => {
  const { state } = useLocation();
  // Article data comes from router state set by useArticleNavigation, not from an API call.
  // If state is absent (e.g. direct URL access or page refresh), state?.new is undefined
  // and we render a skeleton as a graceful fallback.
  const singleNew: Article = state?.new;

  if (!singleNew) {
    return <OtherNewsSkeleton />;
  }

  return (
    <div>
      <div className="container-fluid m-0 pb-0 topic-page-gradient overflow-x-hidden" id="hero">
        <div className="row  ps-1 ps-md-4 pt-5 pb-0 m-0  gy-0 gy-lg-5 flex-column flex-md-row justify-content-between ">
          <div className="col-12 col-md-8 d-flex justify-content-center justify-content-md-start  ps-0 ps-md-2 pb-0  mb-0 "></div>
          <div
            className="col-4  d-flex justify-content-around justify-content-md-evenly align-items-center pb-4"
            style={{ cursor: "pointer" }}
          >
            <a href="https://x.com/EachTechNews">
              <Tweeter />
            </a>
            <a href="https://www.instagram.com/eachonetechone/">
              <Facebook />
            </a>

            <Share />
          </div>
          <div className=" col-12  p-3  p-md-0 p-md-3  ">
            <h1> {stripHTML(singleNew.titulo)}</h1>{/* stripHTML removes HTML tags and entities that TechCrunch includes in title and excerpt fields. */}
          </div>
        </div>
      </div>

      <section className="container-fluid p-0  p-lg-4 bg-secondary ">
        <div className="row justify-content-start mx-3 border-top border-primary border-3 ">
          <div className="col-12 d-flex flex-column flex-md-row pt-3 ">
            <div className="d-flex flex-md-column justify-content-around m-md-3 p-0 text-primary ">
              <p className="fs-7 fs-md-3">Date: {singleNew.fecha}</p>
            </div>
          </div>
        </div>
        <div className="row g-0 g-md-5">
          <div className="col-12 d-flex justify-content-center py-4 px-4">
            <h3> {stripHTML(singleNew.description)}</h3>
          </div>
          <div className="col-12 pt-2  d-flex align-self-start justify-content-center p-5">
            {singleNew.img && (
              <img
                src={singleNew.img}
                alt=""
                className="img-fluid  w-75 rounded"
              />
            )}
          </div>

          <div className="col-12  px-4 px-md-5  d-flex justify-content-center align-items-stretch ">
            {/* cleanHTML sanitizes TechCrunch's WordPress output: removes CTA blocks, fixes inline image dimensions, and normalizes figure elements before injecting into the DOM. */}
            <div
              className="lh-lg news-content"
              dangerouslySetInnerHTML={{ __html: cleanHTML(singleNew.cont) }}
            />
          </div>

          <div className="col-12 p-4">
            <p className="fs-5 px-3">Font:</p>
            <a className="px-4" href={singleNew.url}>
              {" "}
              {singleNew.url}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
